import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import ChargeExclusionCriteriaContMain from "presentation/view/container/Criteria/ChargeExclusionCriteriaContMain";

CommonEntrypoint(<ChargeExclusionCriteriaContMain/>)